import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const imgWrapper: SxStyle = {
  borderRadius: (p) => p.spacing(1),
  overflow: 'hidden',
  position: 'relative',
};

export const videoButtonWrapper: SxStyle = {
  position: 'absolute',
  bottom: (p) => p.spacing(4),
  right: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
